import { v4 } from 'uuid'

import { TNewUserPostResponse } from '~/hooks-queries/user'
import { UserStorageInstance } from '~/hooks/useUser/storage'

import { AxiosClient } from '~/clients/axios'

const SECONDS_TIMEOUT = 20

export const fetchUser = async () => {
  const user = UserStorageInstance.get()

  if (user) {
    return
  }

  const { data } = await AxiosClient().post<TNewUserPostResponse>('/user', undefined, {
    timeout: SECONDS_TIMEOUT * 1000,
    timeoutErrorMessage: `[ERROR][USER] TIMEOUT_WHEN_CREATING_USER`,
  })

  if (data?.uuid) {
    UserStorageInstance.set({
      uuid: data.uuid,
      session_uuid: data?.session_uuid,
      device_id: v4(),
    })
  }
}
